import type {
  AppMaintenancePageAction,
  AppMaintenancePageFlag,
} from './MaintenancePage.types';

const SAFE_URL_PROTOCOLS = new Set(['https:']);

const DEFAULT_PAGE: AppMaintenancePageFlag = {
  enabled: false,
  title: '',
  message: '',
  action: null,
};

function isSafeUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return SAFE_URL_PROTOCOLS.has(parsed.protocol);
  } catch {
    return false;
  }
}

function isValidAction(value: unknown): value is AppMaintenancePageAction {
  if (typeof value !== 'object' || value === null) return false;
  const obj = value as Record<string, unknown>;
  return (
    typeof obj.label === 'string' &&
    typeof obj.url === 'string' &&
    isSafeUrl(obj.url)
  );
}

function parseAppMaintenancePageFlag(flag: unknown): AppMaintenancePageFlag {
  if (typeof flag !== 'object' || flag === null) return DEFAULT_PAGE;
  const obj = flag as Record<string, unknown>;
  if (typeof obj.enabled !== 'boolean') return DEFAULT_PAGE;
  if (typeof obj.title !== 'string') return DEFAULT_PAGE;
  if (typeof obj.message !== 'string') return DEFAULT_PAGE;
  if (
    obj.action !== null &&
    obj.action !== undefined &&
    !isValidAction(obj.action)
  )
    return DEFAULT_PAGE;
  return {
    enabled: obj.enabled,
    title: obj.title,
    message: obj.message,
    action:
      obj.action == null ? null : (obj.action as AppMaintenancePageAction),
  };
}

export { DEFAULT_PAGE, parseAppMaintenancePageFlag };
